/* eslint-disable import/prefer-default-export */
import React from 'react';
import toCurrency from 'utils/toCurrency';
import round from 'utils/round';

const cleanCargos = (e) => e.estados_globales !== 5 && !e?.tipo_de_cargo?.no_aplica_descuento;

const filterDescuentos = (d) => [1].includes(d.estado_del_descuento);

export const normalizeCargos = (cargos) => {
  const _cargos = cargos.filter(cleanCargos)
    .map((item) => {
      const {
        descuentos_aplicables,
        descuentos_especiales,
        actualizaciones,
        recargos,
        gastos: _gastos,
      } = item;
      // Totales por concepto
      const recargo_total = recargos
        .reduce((accum, curr) => accum + (curr.importe_total * 1000), 0) / 1000 || 0;
      const gasto_total = _gastos
        .reduce((accum, curr) => accum + (curr.importe * 1000), 0) / 1000 || 0;
      const actualizacion_total = actualizaciones
        .reduce((accum, curr) => accum + (curr.importe_total * 1000), 0) / 1000 || 0;

      // Descuentos aplicados
      const descuentosAplicablesTotal = descuentos_aplicables.filter(filterDescuentos)
        .reduce((accum, curr) => accum.concat(curr.importe_total), []);
      const descuentosAplicadosRecargos = recargos.reduce(
        (accum, curr) => accum.concat(curr.estado_del_decuento === 2 ? curr.descuentos : 0),
        [],
      );
      const descuentosAplicadosActualizaciones = actualizaciones.reduce(
        (accum, curr) => accum.concat(curr.estados_globales === 2 ? curr.descuentos : 0),
        [],
      );
      const descuentosAplicadosGastos = _gastos.reduce(
        (accum, curr) => accum.concat(curr.estados_globales === 2 ? curr.descuentos : 0),
        [],
      );

      // Descuentos no aplicados
      const descuentosNoAplicadosRecargos = recargos.reduce(
        (accum, curr) => accum.concat(curr.estado_del_descuento === 1 ? curr.descuentos : 0),
        [],
      );
      const descuentosNoAplicadosActualizaciones = actualizaciones.reduce(
        (accum, curr) => accum.concat(curr.estado_del_descuento === 1 ? curr.descuentos : 0),
        [],
      );
      const descuentosNoAplicadosGastos = _gastos.reduce(
        (accum, curr) => accum.concat(curr.estado_del_descuento === 1 ? curr.descuentos : 0),
        [],
      );
      const descuento_total_aplicado = descuentos_especiales
        .filter(filterDescuentos)
        .map((e) => e.importe_total)
        .concat([
          ...descuentosAplicablesTotal,
          ...descuentosAplicadosRecargos,
          ...descuentosAplicadosGastos,
          ...descuentosAplicadosActualizaciones,
          ...descuentosAplicadosGastos,
        ])
        .reduce((accum, curr) => accum + (curr * 1000), 0) / 1000 || 0;
      const descuentos_por_autorizar = descuentos_especiales
        .filter((e) => e.estados_globales !== 4)
        .map((e) => e.importe_total)
        .concat([
          ...descuentosNoAplicadosRecargos,
          ...descuentosNoAplicadosGastos,
          ...descuentosNoAplicadosActualizaciones,
          ...descuentosNoAplicadosGastos,
        ]).reduce((accum, curr) => accum + (curr * 1000), 0) / 1000 || 0;

      const importe_total = round(item.importe - descuento_total_aplicado + recargo_total
        + gasto_total + actualizacion_total);
      const cargoPadre = cargos.find((e) => e.id === item?.cargo_padre) || item?.cargo_padre;
      return {
        ...item,
        cargoPadre,
        key: item.id,
        descuento_total_aplicado,
        descuentos_por_autorizar,
        actualizacion_total,
        recargo_total,
        importe_total: Math.max(0, importe_total),
        gasto_total,
      };
    });

  const cargosPrincipales = _cargos
    .filter((c) => !c.cargo_padre || !c.es_accesorio
  || _cargos.some((a) => a.cargo_padre === c.id || a.id === c.cargo_padre));

  const getAccesories = (cargo_padre) => _cargos
    .filter((e) => e.cargo_padre === cargo_padre && e.es_accesorio);

  const sorted = cargosPrincipales.reduce((acum, curr) => {
    const currCopy = { ...curr };
    currCopy.adicionales = getAccesories(curr.id)
      .reduce((acum2, curr2) => acum2 + curr2.importe_total, 0);
    currCopy.adicionalesLabel = getAccesories(curr.id).map((e) => (
      <li key={e.id}>
        {e.descripcion}
        (
        {toCurrency(e.importe)}
        )
        <br />
        {e.descuentos_aplicables?.length ? 'Descuentos:' : ''}
        <ul>
          {e.descuentos_aplicables.map((i) => (
            <li key={i.id}>
              {i.comentarios}
              {' '}
              (
              {toCurrency(i.importe_total)}
              )
            </li>
          ))}
        </ul>
      </li>
    ));

    return acum.concat([...getAccesories(curr.id), currCopy]);
  }, []).reverse();

  return sorted;
};
